import {Injectable} from '@angular/core';
import * as componentActions from '@catdetails/actions/test-rack';
import {Store} from '@ngrx/store';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";

@Injectable()
export class TestRackService extends RestHttpService<any> {
  constructor(private service: Restangular,
              private store: Store<any>) {
    super('test-racks', service);
  }

  setActive() {
    this.store.dispatch({
        type: componentActions.PROJECT_DETAILS_TEST_RACK_ACTIVATE,
      },
    );
  }

  setInactive() {
    this.store.dispatch({
        type: componentActions.PROJECT_DETAILS_TEST_RACK_DEACTIVATE,
      },
    );
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/test-rack/services/test-rack.service.ts